import { createSlice } from "@reduxjs/toolkit";
import { getCampaignsThunk, getCampaignStatusThunk, getCampaignTagUsersThunk, getCampaignInputParamsThunk, createCampaignThunk } from "./campaignThunk";

const initialState = {
    status: "idle",
    error: null,
    success: "",
    getcampaigns: [],
    viewCampaignDetails: [],
    activeStep: 0,
    campaign_Title: "",
    campaignTagsDetails: [],
    campaignFlowDetails: [],
    scheduleDate: [],
    campaignStatusUsers: [],
    tagWiseUsers: [],
    campaignInputParams: [],
};

const campaignsSlice = createSlice({
    name: "campaigns",
    initialState,
    reducers: {
        resetCampaignState: (state, action) => {
            state.status = "idle";
            state.error = null;
            state.success = "";
            state.getcampaigns = [];
            state.viewCampaignDetails = [];
            state.activeStep = 0;
            state.campaign_Title = "";
            state.campaignTagsDetails = [];
            state.campaignFlowDetails = [];
            state.scheduleDate = [];
            state.campaignStatusUsers = [];
            state.tagWiseUsers = [];
            state.campaignInputParams = [];
        },
        setViewCampaign: (state, action) => {
            state.viewCampaignDetails = action.payload;
        },
        resetActiveBlock: (state, action) => {
            state.activeStep = 0;
            state.campaign_Title = "";
            state.campaignTagsDetails = [];
            state.campaignFlowDetails = [];
            state.scheduleDate = [];
            state.tagWiseUsers = [];
        },
        setActiveNext: (state) => {
            state.activeStep += 1;
        },
        setActiveBack: (state) => {
            if (state.activeStep > 0) state.activeStep -= 1;
        },
        setCampaignTitle: (state, action) => {
            state.campaign_Title = action.payload.campaignTitle ?? "";
        },
        setCampaignTags: (state, action) => {
            state.campaignTagsDetails = action.payload;
        },
        setCampaignFlow: (state, action) => {
            state.campaignFlowDetails = action.payload;
        },
        setScheduleDate: (state, action) => {
            state.scheduleDate = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCampaignsThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getCampaignsThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload?.success ?? false;
                state.error = null;
                state.getcampaigns = action.payload;
            })
            .addCase(getCampaignsThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Campaign failed";
                state.success = "";
            })


            .addCase(getCampaignStatusThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getCampaignStatusThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload?.success ?? false;
                state.error = null;
                state.campaignStatusUsers = action.payload;
            })
            .addCase(getCampaignStatusThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Campaign failed";
                state.success = "";
            })


            .addCase(getCampaignTagUsersThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getCampaignTagUsersThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload?.success ?? false;
                state.error = null;
                state.tagWiseUsers = action.payload;
            })
            .addCase(getCampaignTagUsersThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Campaign failed";
                state.success = "";
                state.tagWiseUsers = [];
            })

            .addCase(getCampaignInputParamsThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getCampaignInputParamsThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload?.success ?? false;
                state.error = null;
                state.campaignInputParams = action.payload;
            })
            .addCase(getCampaignInputParamsThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Campaign failed";
                state.success = "";
            })

            // Add the createCampaignThunk
            .addCase(createCampaignThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(createCampaignThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(createCampaignThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Login failed";
                state.success = "";
            })

    },
});

export const { resetCampaignState, setViewCampaign, setActiveNext, setActiveBack, resetActiveBlock, setCampaignTitle, setCampaignTags, setCampaignFlow, setScheduleDate } = campaignsSlice.actions;
export default campaignsSlice.reducer;